import React, { useState } from "react";
import "../css/Menu.css";
import { Link } from "react-router-dom";
import PhoneIcon from "@material-ui/icons/Phone";
import Menu from "./Menu";
import title from "./title.png";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";

function Nav() {
  return (
    <div>
      <header class="header-area">
        <div class="navbar-area">
          <div class="container">
            <div id="menu-button">
              <Menu style={{ display: "none" }} />
            </div>
            <nav class="site-navbar stroke">
          <Link to="/"><img src={title} id="title-image"/></Link>
              <div id="list">
                <ul>
                  <li>
                    <Link to="/details">About</Link>
                  </li>

                  <li>
                    <Link to="/appointment">Appointment</Link>
                  </li>

                  <li>
                    <a href="/address">Address</a>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
       
        <div id="right-header">
          <div id="sub-header">
         <h4 style={{
            color: "white",
          }}> Need help? Contact Us:
        </h4>
       
          <a href="tel:+919830310787">
            <div id="icon-text">
              <PhoneIcon
                style={{
                  color: "white",
                  fontSize: 20,
                  marginRight: "0.1rem",
                }}
                id="icon-container"
              />
              +91 9830310787
            </div>
          </a>

          <div>
            <a
              href="https://api.whatsapp.com/send?phone=919830310787"
              target="_blank"
            >
              <div id="icon-text">
                <WhatsAppIcon
                  style={{
                    color: "white",
                    fontSize: 20,
                    marginRight: "0.3rem",
                  }}
                  id="icon-container"
                />
                WhatsApp
              </div>
            </a>
          </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default Nav;
